import React, { useEffect } from "react";
import StandardTemplate from "../../../templates/standard_template/standard_template";
import DscrCalculatorForm from "../../../components/loan_tools/forms/dscr_calculator";
import { useDocument } from "../../../components/loan_tools/loan_tool";

export default function DscrCalculatorRoute() {
  const [loanDoc, , , actions] = useDocument();

  useEffect(() => {
    const borrowers = loanDoc && loanDoc.applicant && loanDoc.applicant.borrowers;
    const lastName = (borrowers && borrowers[0] && borrowers[0].last_name) || "";
    const title = lastName ? `${lastName} DSCR Calculator` : "DSCR Calculator";
    actions.setPageTitleOverride(title);
    return () => actions.setPageTitleOverride(null);
  }, [loanDoc]);

  return (
    <StandardTemplate className="ba-template">
      <div className="ba-page-actions no-print">
        <button className="button" onClick={() => window.print()}>
          Print Now
        </button>
      </div>
      <DscrCalculatorForm />
    </StandardTemplate>
  );
}
